module.exports = __webpack_public_path__ + "img/gz02.45030385.png";